<template>
    <CreatePopup v-if="newArticleDialog" v-model="newArticleDialog" :flowtype="'Article'" @create="addNewArticle($event)"/>
    <div class="articles-main-container">
        <div v-if="comingSoon" class="coming-soon">
        <ComingSoon title="Author" subtitle="Thought Leadership Articles" 
        description="Create thought leadership articles to establish credibility, share insights, and shape conversations. Build your reputation as an industry authority and drive engagement with original perspectives."
        :title-image="require('@/assets/icons/article-colored.svg')" />
   
        </div>
        <div v-else-if="pageLoader" class="no-data">
            <RotatingLoader :size="30" :speed="0.6" label="Loading..." />
        </div>
        <div v-else class="articles-wrapper">
            <div class="main-header">
                <div class="title">Articles</div>
                <button v-if="articlesList.length > 0" @click=" newArticleDialog = true" class="create-article-btn">
                    <Svg :src="require('@/assets/icons/add.svg')" alt="add"></Svg>
                    <!-- <Svg :src="require('@/assets/icons/create-icon.svg')" alt="create"></Svg> -->
                    <span>Create</span>
                    <!--<div class="value">(
                    <Svg :src="require('@/assets/icons/diamond.svg')" alt="add"></Svg>
                    20 )
                    </div>-->
                </button>
            </div>

            <div v-if="draftCount == 0 && completedCount == 0 && !filterState" class="no-article">
                <EmptyState :title="'No Articles Created!'" :stage="'DRAFT'"
                    :subTitle="'Create a new articles to see it listed here.'" @create-dialog="newArticleDialog = true">
                </EmptyState>
            </div>

            <div v-else class="mid-section">
                <div class="toggle-container">
                    <div class="toggle-buttons">
                        <button class="toggle-button" :class="{ active: selectedTab === 'draft' }"
                            @click="toggleTab('draft')">
                            Draft<span> ({{ draftCount }})</span>
                        </button>
                        <button class="toggle-button" :class="{ active: selectedTab === 'completed' }"
                            @click="toggleTab('completed')">
                            Complete <span>({{ completedCount
                            }})</span>
                        </button>
                    </div>

                    <div v-if="(selectedTab === 'draft' && draftCount !== 0) || (selectedTab === 'completed' && completedCount !== 0) || filterState"
                        class="filter-Page">
                        <v-menu v-model="dateMenu" :close-on-content-click="false">
                            <template v-slot:activator="{ props }">
                                <div class="selected-date-container">
                                    <button class="filter-btn" v-bind="props">
                                        <Svg :src="require('@/assets/icons/calendar.svg')" stroke='#030712'></Svg>
                                        <span v-if="displayDateValue">{{ displayDateValue }}</span>
                                        <span class="text" v-else>Filter by Date</span>
                                    </button>
                                    <v-icon v-if="filterStartDate" @click="clearFilterDates">mdi-close</v-icon>
                                </div>
                            </template>
                            <v-date-picker v-model="selectedDate" :max="new Date()" multiple="range"
                                @update:model-value="updateFilterDate(false)">
                                <template #actions>
                                    <div class="action-btns">
                                        <v-btn @click="clearFilterDates" class="ok-btn">Cancel</v-btn>
                                        <v-btn @click="updateFilterDate(true)" class="ok-btn"
                                            :disabled="selectedDate.length === 0">OK</v-btn>
                                    </div>
                                </template>
                            </v-date-picker>
                        </v-menu>

                        <div class="view-toggle-container">
                            <button @click="selectedView = 'list'"
                                :class="{ 'active': selectedView === 'list', 'view-icon': true }">
                                <Svg :src="require('@/assets/icons/list.svg')"></Svg>
                            </button>
                            <button @click="selectedView = 'grid'"
                                :class="{ 'active': selectedView === 'grid', 'view-icon': true }">
                                <Svg :src="require('@/assets/icons/grid.svg')"></Svg>

                            </button>

                        </div>

                    </div>
                </div>
                <RenamePopup v-if="isEditing" :docName="currentRenameItem.articleDocumentName"
                    :id="currentRenameItem.articleId" :isEditing="isEditing" @update-isEdit="isEditing = $event"
                    @updated-prTitle="handleTitleUpdate($event)" flowType="article" />
                <div v-if="selectedTab === 'draft' && draftCount === 0" class="no-article">
                    <EmptyState :title="'No Draft Articles!'" :stage="'DRAFT'" :filter="filterState"
                        :subTitle="filterState?'No Articles match your filters..':'Create a new Articles to see it listed here.'"
                        @create-dialog="newArticleDialog = true">
                    </EmptyState>
                </div>
                <div v-if="selectedTab === 'completed' && completedCount === 0" class="no-article">
                    <EmptyState :title="'No completed Articles!'" :stage="'COMPLETED'"
                        :subTitle="filterState?'No Articles match your filters..':'Create a new Articles to see it listed here.'"
                        @create-dialog="newArticleDialog = true">
                    </EmptyState>
                </div>


                <div class="table-container" v-if="selectedView === 'list' && articlesList.length > 0">
                    <v-data-table class="table-wrapper" :headers="tableHeaders" :items="articlesList" :hover="true"
                        :items-per-page="itemsPerPage" :page="page" @click:row="redirectToDetailsPage">
                        <template v-slot:[`item.userName`]="{ item }">
                            <div class="avatar">
                                <img v-if="item?.profileAvatar" :src="item?.profileAvatar" class="profile-icon"
                                    alt="User Avatar" />
                                <div class="profile-icon no-avatar" v-else>{{ item?.userName?.[0] }}</div>
                                <div class="author">{{ item?.userName }}</div>
                            </div>

                        </template>
                        <template v-slot:[`item.createdAt`]="{ item }">
                            {{ convertEpochToDate(item?.createdAt) }}
                        </template>
                        <template v-slot:[`item.completedAt`]="{ item }">
                            {{ convertEpochToDate(item?.completedAt) }}
                        </template>
                        <template v-slot:[`item.updatedAt`]="{ item }">
                            {{ convertEpochToDate(item?.updatedAt) }}
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
                                <template v-slot:activator="{ props }">
                                    <div class="more-button-wrapper">
                                        <img style="height: 16px; width: 16px;"
                                            :src="require('@/assets/icons/more.svg')" alt="more" v-bind="props">
                                    </div>
                                </template>
                                <div class="more-options-contaioner">
                                    <div @click="renameArticleDoc(item)" class="bottom-border more-option-img-wrapper">
                                        <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                                        <p>Rename</p>
                                    </div>
                                    <div class="more-option-img-wrapper" @click="deleteArticle(item)">
                                        <Svg :src="require('@/assets/icons/delete.svg')" fill='#404040'
                                            alt="delete"></Svg>
                                        <p>Delete</p>
                                    </div>
                                </div>
                            </v-menu>
                        </template>
                    </v-data-table>
                </div>

                <div class="pr-grid" v-else-if="selectedView === 'grid' && articlesList.length > 0">
                    <div v-for="(item, index) in articlesList" :key="index" class="pr-card"
                        @click="redirectToDetailsPage(event, { item })">
                        <div class="pr-more-container">
                            <div class="pr-content">{{ item.articleDocumentName }}</div>
                            <div class="more-container">
                                <v-menu v-model="item.showMoreMenu" :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <img :src="require('@/assets/icons/more.svg')" alt="more" v-bind="props">
                                    </template>
                                    <div class="more-options-container">
                                        <div @click="renameArticleDoc(item)"
                                            class="bottom-border more-option-img-wrapper">
                                            <img :src="require('@/assets/icons/rename.svg')" alt="rename">
                                            <p>Rename</p>
                                        </div>
                                        <div class="more-option-img-wrapper" @click="deleteArticle(item)">
                                            <Svg :src="require('@/assets/icons/delete.svg')" fill='#404040'
                                                alt="delete"></Svg>
                                            <p>Delete</p>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
                        </div>
                        <div class="pr-footer">
                            <div class="avatar">
                                <img v-if="item.profileAvatar" :src="item.profileAvatar" class="profile-icon"
                                    alt="User Avatar" />
                                <div class="profile-icon no-avatar" v-else>{{ item?.userName[0] }}</div>
                                <div class="author">{{ item.userName }}</div>
                            </div>
                            <div class="meta-info">
                                <div class="timestamp">{{ convertUpdatedTime(item.updatedAt).date }}</div>
                                <div class="seperator"></div>
                                <div class="timestamp">{{ convertUpdatedTime(item.updatedAt).time }}</div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handleConfirmation" />
    <ConfirmPopup v-if="confirmPopup" v-model="confirmPopup" :title="'Article discarded'" :image="deleteImage"
        :type="'success'" />
</template>

<script>
import RenamePopup from '@/components/RenamePopup.vue';
import CommonPopup from '@/components/CommonPopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue'
import EmptyState from '@/components/EmptyState.vue';
import axiosInstance from '@/axiosInterceptor';
import moment from 'moment-timezone';
import { Eventbus } from '@/plugins/eventBus';
import ConfirmPopup from '@/components/ConfirmPopup.vue';
import CreatePopup from '@/components/CreatePopup.vue';
import ComingSoon from '@/components/ComingSoon.vue';
export default {
    name: 'ArticleHome',
    components: {
        RenamePopup, CommonPopup, RotatingLoader, EmptyState, ConfirmPopup, CreatePopup,ComingSoon
    },

    data() {
        return {
            pageLoader: false,
            comingSoon:false,
            articlesList: [],
            newArticleDialog: false,
            docName: null,
            draftCount: null,
            completedCount: null,
            isFormValid: false,
            newArticleBtnLoader: false,
            selectedTab: 'draft',
            dateMenu: false,
            displayDateValue: null,
            filterStartDate: null,
            filterStartDate: null,
            deleteImage: require('@/assets/icons/delete_red.svg'),
            filterEndDate: null,
            selectedDate: [],
            selectedView: 'grid',
            confirmPopup: false,
            tableHeaders: [
                { title: 'Document Name', key: 'articleDocumentName' },
                { title: 'Created By', key: 'userName' },
                { title: 'Created Date', key: 'createdAt' },
                { title: 'Last Edited', key: 'updatedAt' },
                { title: 'Actions', key: 'actions' },
            ],
            selectRules: [
                v => !!v || 'This field is required',
                v => v.length > 0 || 'This field is required'
            ],
            perPage: [
                { name: '5', value: 5 },
                { name: '10', value: 10 },
                { name: '25', value: 25 },
                { name: 'All', value: -1 }
            ],
            page: 1,
            itemsPerPage: 10,
            isEditing: false,
            showCommonPopup: false,
            popupType: 'delete',
            filterState: false
        }
    },

    methods: {
        async addNewArticle(docName) {
            this.newArticleBtnLoader = true;
            let payload = {
                articleDocumentName: docName
            }

            let endpoint = '/article/create';
            await axiosInstance.post(endpoint, payload)
                .then((response) => {
                    this.newArticleBtnLoader = false;
                    this.$router.push(`/article/${response.data.data.articleId}`);
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to create new article'
                    })
                })
                .finally(() => {
                    this.newArticleBtnLoader = false;
                    this.newArticleDialog = false;
                })
        },

        async getAllArticles() {
            this.pageLoader = true;
            let endpoint = '/article';
                await axiosInstance.get(endpoint,{
                params:{
                    startDate: this.filterStartDate,
                    endDate: this.filterEndDate,
                }
            })
                .then((response) => {
                    this.articlesList = response.data.data;
                    if (this.filterStartDate && this.filterEndDate) {
                        
                        this.filterState = true;
                    } else {
                        this.filterState = false;
                    }
                    const completed = this.articlesList.filter(article => article.statusValue === 'COMPLETED').sort((a, b) => b.updatedAt - a.updatedAt);
                    const draft = this.articlesList.filter(article => article.statusValue === 'DRAFT').sort((a, b) => b.updatedAt - a.updatedAt); this.completedCount = completed.length;
                    this.completedCount = completed.length;
                    this.draftCount = draft.length;
                    this.articlesList = this.selectedTab === 'draft' ? draft : completed;
                    this.pageLoader = false;
                })
                .catch((error) => {
                    Eventbus.emit({
                        snackType: 'error',
                        message: 'Failed to fetch article'
                    })
                })
                .finally(() => {
                    this.pageLoader = false;
                })

        },

        renameArticleDoc(item) {
            this.isEditing = true;
            this.currentRenameItem = item
        },

        deleteArticle(item) {
            this.showCommonPopup = true;
            this.deletedArticle = item;
        },

        async handleTitleUpdate(event) {
            this.currentRenameItem.articleDocumentName = event
            await this.getAllArticles();
        },

        toggleTab(tab) {
            this.selectedTab = tab;
            this.getAllArticles();
        },

        clearFilterDates() {
            this.selectedDate = [];
            this.filterStartDate = null;
            this.filterEndDate = null;
            this.dateMenu = false;
            this.displayDateValue = null;
            this.getAllArticles();
        },

        async updateFilterDate(okBtnClicked) {
            if (this.selectedDate.length > 1) {
                this.filterStartDate = moment(this.selectedDate[0]).valueOf();
                this.filterEndDate = moment(this.selectedDate[this.selectedDate.length - 1]).valueOf();
                this.displayDateValue = moment(this.selectedDate[0]).format('DD/MM/YYYY') + ' - ' + moment(this.selectedDate[this.selectedDate.length - 1]).format('DD/MM/YYYY');
                this.dateMenu = false;
                this.getAllArticles();
            } else if (okBtnClicked) {
                this.filterStartDate = moment(this.selectedDate[0]).valueOf();
                this.filterEndDate = moment(this.selectedDate[0]).endOf('day').valueOf();
                this.displayDateValue = moment(this.selectedDate[0]).format('DD/MM/YYYY');
                this.dateMenu = false;
                this.getAllArticles();
            }
        },

        redirectToDetailsPage($event, { item }) {
            this.$router.push({ name: 'ArticleStages', params: { articleId: item.articleId } });
        },

        convertUpdatedDate(date) {
            return moment(date).format("Do MMM YYYY");
        },

        convertUpdatedTime(date) {
            return {
                date: moment(date).format("Do MMM, YYYY"),
                time: moment(date).format("hh:mmA")
            };
        },

        convertEpochToDate(time) {
            return moment(time).format('DD/MM/YYYY');
        },
        handleConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                axiosInstance.put('/article/delete', { articleId: this.deletedArticle.articleId })
                    .then((response) => {
                        if (response.status === 200) {
                            this.confirmPopup = true;
                            setTimeout(() => {
                                this.confirmPopup = false;
                                this.$router.push({ name: 'ArticleHome' });
                            }, 1000);
                            this.getAllArticles();
                        }
                    })
                    .catch((error) => {
                        console.error('Error while deleting Article', error);
                        Eventbus.emit('commonSnackbar', {
                            snackType: "failed",
                            message: 'Failed to delete Article'
                        });
                    })
                    .finally(() => {
                        this.deletedPr = null;
                        this.showCommonPopup = false;
                    })
            }
        },
    },

    computed: {
        totalPages() {
            return Math.ceil(this.articlesList.length / this.itemsPerPage);
        }
    },

    async mounted() {
        this.pageLoader = true;
        this.selectedTab = this.$route.query.status ? this.$route.query.status.toLowerCase() : 'draft';
        this.getAllArticles();
    }
}
</script>

<style scoped>
/* Popup CSS */
.popup {
    display: flex;
    flex: 1;
    flex-direction: column;
    background: white;
    border: 1px solid #E0E9ED;
    border-radius: 8px;
}

.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    font-weight: 600;
    font-family: 'OverpassMono';
    font-size: 20px;
}

.optional {
    opacity: 0.4;
}

.circle {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 8px;
    border: 2px solid #D4D4D4;
}

.popup-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    overflow: auto;
    flex: 1;
}

.popup-input {
    display: flex;
    flex-direction: column;
    gap: 12px;
    font-weight: 500;
}

.popup-footer {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
}

.create-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #171717;
    color: white;
    border: 1px solid #525252;
    border-radius: 8px;
    font-weight: 500;
    flex: 1;
}

.cancel-btn {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    padding: 12px;
    background: white;
    border: 1px solid #525252;
    border-radius: 8px;
    font-weight: 500;
}


.articles-main-container {
    display: flex;
    background: white;
    gap: 1rem;
    flex-grow: 1;
    border-radius: 16px;
    padding: 2rem;
}

.no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
}

.articles-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    gap: 1rem;
}

.main-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.title {
    font-size: var(--title-font-size);
    font-weight: bold;
    border-bottom: 16px;
    font-family: 'OverpassMono';
}

.create-article-btn {
    display: flex;
    background: black;
    flex-direction: row;
    color: var(--secondary-font-color);
    border-radius: 8px;
    align-items: center;
    gap: 0.5rem;
    padding: 0rem 1.5rem;
    font-family: 'OverpassMono';
}

.no-article {
    display: flex;
    flex-direction: column;
    padding: 2rem;
    border: 1px solid #E5E5E5;
    border-radius: 12px;
    background-color: #FAFAFA;
    gap: 20px;
    flex: 1;
}
.coming-soon{
    display: flex;
    flex-direction: column;
    background-color: #FAFAFA;
    flex: 1;
     border-radius: 16px;
}


.mid-section {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    flex: 1;
    min-height: 0;
}

.toggle-container {
    display: flex;
    justify-content: space-between;

}

.toggle-buttons {
    display: flex;
    gap: 10px;
    border: 1px solid #A3A3A3;
    padding: 4px;
    border-radius: 8px;

}

.toggle-button {
    display: flex;
    flex: 1;
    padding: 10px 30px;
    border-radius: 8px;
    font-family: 'OverpassMono';
}


.toggle-button.active {
    background-color: black;
    color: white;
}

.toggle-button:hover {
    background-color: black;
    color: white;
}

.filter-Page {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
}

.selected-date-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 40px;
    padding: 4px 8px;
    border-radius: 8px;
    border: 1px solid #D4D4D4;
    color: #030712;
}

.filter-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    flex: 1;
}

.action-btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.ok-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #A3A3A3;
    border-radius: 4px;
}

.view-toggle-container {
    display: flex;
    border: 1px solid #D4D4D4;
    height: 38px;
    border-radius: 8px;
}

.view-icon {
    display: flex;
    align-items: center;
    padding: 8px 16px;
}

.view-icon.active {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: #F1F4FB;
}

.view-icon.active {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background-color: #F1F4FB;
}

.view-icon:first-child {
    border-right: 1px solid #D4D4D4;
}

.view-icon.active svg {
    fill: #171717;
}


.table-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
}

.table-wrapper {
    border-radius: 8px;
    height: 100%;
    scrollbar-width: thin;
    justify-content: center;
    align-items: end;
    will-change: transform;
}

.table-container :deep(.v-table__wrapper tr:hover) {
    background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper) {
    width: 100%;
    scrollbar-width: thin;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
}

.table-wrapper :deep(.v-table__wrapper thead) {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper thead tr th) {
    font-weight: 600 !important;
    color: var(--primary-font-color);
}

.table-wrapper :deep(.v-table__wrapper tbody) {
    max-height: 700px;
    color: var(--dark-grey-color);
}

.table-wrapper :deep(.v-data-table-footer) {
    background: #F1F4FB !important;
    padding: 0rem 0rem 0rem 1rem;
    margin: 1rem;
    height: 5rem;
    border-radius: 8px;
    border: 1px solid #E5E5E5;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__first) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__last) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control) {
    height: 2rem;
    width: 4rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__input) {
    padding: 0px 16px 8px 16px;
    font-size: 14px;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__field) {
    height: 2rem;
    width: 3rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__append-inner) {
    width: 1rem;
}

.table-wrapper :deep(.v-data-table-footer .v-data-table-footer__items-per-page > .v-select) {
    width: 63px;
    background: #ffffff;
}

.table-container :deep(.v-table__wrapper tr:hover) {
    background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper) {
    width: 100%;
    scrollbar-width: thin;
    border: 1px solid #E5E5E5;

}

.table-wrapper :deep(.v-table__wrapper thead) {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: #F1F4FB !important;
}

.table-wrapper :deep(.v-table__wrapper thead tr th) {
    font-weight: 600 !important;
    color: var(--primary-font-color);
}

.table-wrapper :deep(.v-table__wrapper tbody) {
    max-height: 700px;
    color: var(--dark-grey-color);
}

.table-wrapper :deep(.v-data-table-footer) {
    background: #F1F4FB !important;
    padding: 0rem 0rem 0rem 1rem;
    margin: 1rem;
    height: 5rem;
    border-radius: 8px;
    border: 1px solid #E5E5E5;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__first) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-pagination__list .v-pagination__last) {
    display: none;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control) {
    height: 2rem;
    width: 4rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__input) {
    padding: 0px 16px 8px 16px;
    font-size: 14px;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__field) {
    height: 2rem;
    width: 3rem;
}

.table-wrapper :deep(.v-data-table-footer .v-input__control .v-field__append-inner) {
    width: 1rem;
}

.table-wrapper :deep(.v-data-table-footer .v-data-table-footer__items-per-page > .v-select) {
    width: 63px;
    background: #ffffff;
}

.profile-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    overflow: hidden;
    font-size: 14px;
}

.avatar {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;
}

.no-avatar {
    background: linear-gradient(90deg, #FF00C3, #FF0A19, #FF7800);
    color: white;
}

.author {
    font-weight: 500;
}

.more-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #E5E5E5;
    width: 2rem;
    height: 2rem;
    border-radius: 8px;
}

.more-options-contaioner {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 0px #0000000F, 0px 0px 4px 0px #0000000A;
}

.more-option-img-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
    padding: 1rem;
}

.pr-grid {
    display: grid;
    min-height: 0;
    overflow-y: auto;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 1.5rem;
    will-change: transform;
    scrollbar-width: thin;
}

.pr-card {
    display: flex;
    gap: 16px;
    border: 1px solid #E5E5E5;
    background: #FAFAFA;
    flex-direction: column;
    padding: 1rem;
    border-radius: 8px;
    cursor: pointer;
}

.pr-more-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pr-content {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-weight: 600;
}

.more-options-container {
    min-width: 180px;
    display: flex;
    flex-direction: column;
    background: white;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    box-shadow: 0px 4px 8px 0px #0000000F, 0px 0px 4px 0px #0000000A;
}

.bottom-border {
    border-bottom: 1px solid #E5E5E5;
}

.pr-footer {
    display: flex;
    padding-top: 12px;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #E5E5E5;
    font-size: 14px;
    color: #525252;
}

.meta-info {
    color: #ccc;
    display: flex;
    gap: 4px;
    align-items: center;
    flex-direction: row;
}

.timestamp {
    font-weight: 500;
    color: #A3A3A3
}
</style>